import { Component, OnInit, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, NgForm } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { environment } from '@environments/environment';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { pushToDataLayer } from '@helpers/gtm.util';

@Component({
  selector: 'login-wettarena-component',
  templateUrl: './login-wettarena.component.html',
})
export class LoginWettarenaComponent implements OnInit, AfterViewInit {
  darkThemeChecked = false;
  quickTippChecked = false;
  IsRegisterActive = true;
  isError_reCaptcha = false;
  isError_fiveMinutes = false;
  lastLoginDate = new Date();
  isError = false;
  errorMessage: string;
  loginDatas: UntypedFormGroup;
  loginDataRaw: any;
  env;
  isLoginRoute = false;

  isBoxShow = false;
  box = {
    show: false,
    msg: '',
    status: '',
  };
  token: string | undefined;
  isMobileView = false;

  constructor(
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    public _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper,
    private _BottomSheet: MatBottomSheet,
    public dialog: MatDialog
  ) {
    this.token = undefined;
    this.env = environment.mobile;
    this.IsRegisterActive = environment.IsRegisterActive;
    this.loginDatas = _FormBuilder.group({
      userName: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(2)]),
      userPassword: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(5)]),
    });

    const theme = this._UiHelper.currentTheme;

    if (theme == 'dark') {
      this.darkThemeChecked = true;
    }

    this.quickTippChecked = this._UiHelper.getQuickTipp();

    this._UiHelper.windowsWidth < 990 ? (this.isMobileView = true) : (this.isMobileView = false);
    this._UiHelper.windowResized.subscribe(x => {
      if (x.w <= 990) {
        this.isMobileView = true;
      } else {
        this.isMobileView = false;
      }
    });
  }

  sendRecaptcha(form: NgForm): void {
    if (form.invalid) {
      for (const control of Object.keys(form.controls)) {
        form.controls[control].markAsTouched();
      }
      return;
    }
    this.isError_reCaptcha = false;
    this.isError = false;
    console.warn(`Token [${this.token}] generated`);
  }

  changeTheme() {
    this._UiHelper.darkThemeListener.emit();
  }

  submitLoginData() {
    const translator = new TranslatePipe(this._LocalizationService);

    const userName = document.getElementById('login_userName') as HTMLInputElement;
    const userPassword = document.getElementById('login_userPassword') as HTMLInputElement;

    try {
      if (userName && userPassword) {
        this.loginDatas.setValue({
          userName: userName.value,
          userPassword: userPassword.value,
        });
      }
    } catch (e) {
      console.error('Cannot obtain login fields.');
    }

    if (!this.loginDatas.valid) {
      return this._UiHelper.errorSnackBar(translator.transform('b3000_fill_all_fields', null), '');
    }

    this._ApiService.signIn(this.loginDataRaw).then(result => {
      if (result.code == '') {
        return 'error|System Error';
        this.isError = true;
      } else {
        if (result.code == 'error') {
          pushToDataLayer({ event: 'login_failed', error_code: result.message });
          // let t_message = translator.transform(result.message, null);
          this.isError = true;
          this.errorMessage = result.message;
          this.show_box('red', result.message);
          this.isError_fiveMinutes = false;

          this._UiHelper.errorSnackBar(result.message, '');
        } else if (result.code == 'errorcode') {
          pushToDataLayer({ event: 'login_failed', error_code: result.message });
          this.isError = true;
          this.errorMessage = result.message;
          const t_message = translator.transform(result.message, null);
          this._UiHelper.errorSnackBar(t_message, '');
          this.show_box('red', t_message);
          this.isError_fiveMinutes = false;
        } else if (result.code === 'error_reCaptcha') {
          this.isError_reCaptcha = true;
          pushToDataLayer({ event: 'login_failed', error_code: result.message });
          this.isError = true;
          this.errorMessage = result.message;
          // const t_message = translator.transform(result.message, null);
          this._UiHelper.errorSnackBar(result.message, '');
          this.show_box('red', result.message);
          this.isError_fiveMinutes = false;
        } else if (result.code === 'error_five_minutes') {
          pushToDataLayer({ event: 'login_failed', error_code: result.message });
          this.isError = true;
          this.isError_fiveMinutes = true;
          this.errorMessage = '';
          this.lastLoginDate = new Date(result.message);

          const t_message = translator.transform('fiveminutes_error', null);
          this._UiHelper.errorSnackBar(t_message, '');
          this.show_box('red', t_message);
        } else if (result.code == 'success') {
          pushToDataLayer({ event: 'login_success' });
          if (environment.transactionDialogIsActive) {
            this._UserHelper.transactionsDialogListener.emit();
          }
          this._ApiService.getClient().then(result => {
            this._UserHelper.setUser(result);
            this._ApiService.getWalletList().then(result => {
              this._UserHelper.setWalletList(result);
            });
            this._UiHelper.closeDimmer();
            const t_message = translator.transform('welcome_msg', null);
            this._UiHelper.successSnackBar(t_message + ' ' + this._UserHelper.customerUser.UserName, '');
            if (environment.loginredirect == 'bookings') {
              this._router.navigate(['/bookings']);
            } else {
              this._router.navigate(['/home']);
            }

            this._UiHelper.changeStatusRightMenu(false);
          });
          this._UiHelper.b3000SetRightMenuState('close');

          this._ApiService.getTaxRate().then(result => {
            this._DataHelper.setTaxRate(result);
          });
        } else if (result.code == 'success1') {
          pushToDataLayer({ event: 'login_success' });
          if (environment.transactionDialogIsActive) {
            this._UserHelper.transactionsDialogListener.emit();
          }
          this._ApiService.getClient().then(result => {
            this._UserHelper.setUser(result);
            this._ApiService.getWalletList().then(result => {
              this._UserHelper.setWalletList(result);
            });
            this._router.navigate(['/home']);
            const t_message = translator.transform('welcome_msg', null);
            this._UiHelper.successSnackBar(t_message + ' ' + this._UserHelper.customerUser.UserName, '');
          });

          this._UiHelper.b3000SetRightMenuState('close');
        }
      }
    });
  }

  ngOnInit() {
    this.loginDatas.valueChanges.subscribe(x => {
      this.loginDataRaw = x;
    });
  }

  ngAfterViewInit() {
    this._router.url == '/login' ? (this.isLoginRoute = true) : (this.isLoginRoute = false);

    setTimeout(x => {
      window.scroll(0, 0);
    }, 200);
  }

  show_box(status, msg) {
    this.isBoxShow = true;
    this.box = {
      show: true,
      msg: msg,
      status: status,
    };
  }

  goRegisterPage() {
    // this._BottomSheet.open(CurrentSlipComponent, { panelClass: 'currentSlipBS' });
    this._BottomSheet.dismiss();

    this._router.navigate(['register']);
  }

  goForgotPasswordPage() {
    this._router.navigate(['forgotpassword']);
  }

  refresh() {
    this._ApiService.userLoggedInSuccessfully().then();
  }

  closeSideBar() {
    document.getElementById('rightSidenav').style.width = '0';
  }

  contactButton() {
    return window.open(`mailto:${environment.contactUrl}`, '_blank');
  }
}
